export default function apiErrorFormatter(err) {
  switch (err?.response?.status) {
    case 403:
      return ['common:forbidden'];
    case 401:
      return ['common:unauthorized'];
    case 400:
      const errorMessage = err?.response?.data;
      if (errorMessage === undefined) {
        return ['common:api_error'];
      } else {
        if (errorMessage?.errorMessages) {
          return errorMessage.errorMessages;
        } else if (errorMessage) {
          if (typeof errorMessage === 'object') {
            if (errorMessage?.status) {
              return [errorMessage.status];
            } else {
              return ['common:api_server_error'];
            }
          } else {
            return [errorMessage];
          }
        } else {
          return ['common:api_internal_server_error'];
        }
      }
    default:
      return ['common:api_error'];
  }
}
